import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuReadiness from "@/pages/EuReadiness";

export const Route = createFileRoute("/en/eu-readiness")({
  head: () => buildRouteHead("/en/eu-readiness"),
  component: EuReadiness,
});

